module.exports = __webpack_public_path__ + "static/media/new.d4837e43.svg";